import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import "./FadeIn.css";

const useStyles = makeStyles((theme) => ({
  educationContainer: {
    backgroundColor: "#141414",
    width: "100%",
    paddingBottom: "100px",
    paddingTop: "100px",
  },
  sectionTitle: {
    color: "#FFFFFF",
    fontWeight: 700,
    marginBottom: "60px",
    position: "relative",
    display: "inline-block",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "-12px",
      left: 0,
      width: "60px",
      height: "4px",
      background: "#00FF41",
      borderRadius: "2px",
    },
  },
  educationCard: {
    background: "rgba(10, 10, 10, 0.8)",
    backdropFilter: "blur(10px)",
    border: "1px solid #2A2A2A",
    borderRadius: "16px",
    padding: "32px",
    marginBottom: "24px",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "rgba(0, 255, 65, 0.3)",
      transform: "translateX(8px)",
    },
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: 0,
    },
  },
  logo: {
    maxWidth: "200px",
    maxHeight: "140px",
    objectFit: "contain",
    filter: "brightness(1.1)",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  schoolName: {
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "1.25rem",
    marginBottom: "8px",
  },
  degree: {
    color: "#B0B0B0",
    fontSize: "0.95rem",
    marginBottom: "12px",
  },
  detailsRow: {
    display: "flex",
    gap: "24px",
    flexWrap: "wrap",
  },
  detailItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  detailLabel: {
    color: "#707070",
    fontSize: "0.85rem",
    fontWeight: 500,
  },
  detailValue: {
    color: "#FFFFFF",
    fontSize: "0.85rem",
  },
}));

const education = [
  {
    logo: "/images/education/springboard.png",
    name: "Springboard Software Engineering Program",
    degree: "Certificate of Completion (April 2021)",
    logoWidth: "240px",
  },
  {
    logo: "/images/education/cpa.png",
    name: "Certified Public Accountant Exam",
    degree: "Passed all 4 sections of the CPA exam",
    note: "* Not currently an active CPA",
    logoWidth: "300px",
  },
  {
    logo: "/images/education/uofi.png",
    name: "University of Idaho",
    degree: "B.S. in Business - Accounting (Mar 2012) & Finance (Dec 2012)",
    gpa: "3.5",
    location: "Moscow, Idaho",
    logoWidth: "180px",
  },
  {
    logo: "/images/education/ghana.png",
    name: "University of Ghana",
    degree: "Study abroad semester (Spring 2010)",
    gpa: "3.9",
    location: "Accra, Ghana, Africa",
    logoWidth: "300px",
  },
];

export default function Education() {
  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.educationContainer}>
      <span
        id="Education"
        style={{ position: "absolute", marginTop: "-80px" }}
      ></span>
      <Container maxWidth="md">
        <Typography variant="h4" className={classes.sectionTitle}>
          Education
        </Typography>

        {education.map((item, index) => (
          <div className={classes.educationCard} key={index}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} sm={3} className={classes.logoContainer}>
                <img
                  src={item.logo}
                  className={classes.logo}
                  style={{ maxWidth: item.logoWidth }}
                  alt={item.name}
                />
              </Grid>
              <Grid item xs={12} sm={9} className={classes.contentContainer}>
                <Typography className={classes.schoolName}>
                  {item.name}
                </Typography>
                <Typography className={classes.degree}>
                  {item.degree}
                  {item.note && (
                    <span style={{ color: "#707070", marginLeft: "8px" }}>
                      {item.note}
                    </span>
                  )}
                </Typography>
                {(item.gpa || item.location) && (
                  <div className={classes.detailsRow}>
                    {item.gpa && (
                      <div className={classes.detailItem}>
                        <Typography className={classes.detailLabel}>
                          GPA:
                        </Typography>
                        <Typography className={classes.detailValue}>
                          {item.gpa}
                        </Typography>
                      </div>
                    )}
                    {item.location && (
                      <div className={classes.detailItem}>
                        <Typography className={classes.detailLabel}>
                          Location:
                        </Typography>
                        <Typography className={classes.detailValue}>
                          {item.location}
                        </Typography>
                      </div>
                    )}
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        ))}
      </Container>
    </Grid>
  );
}
